import script from "./UserQuestionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserQuestionList.vue?vue&type=script&setup=true&lang=ts"

import "./UserQuestionList.vue?vue&type=style&index=0&id=88737652&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88737652"]])

export default __exports__